import React, { useState, useEffect } from 'react';
// import './Checkout.css'; // Import the CSS file for styling
import { getCartItems } from '../helper/cart';
import { Spin, message } from 'antd';
import countryRegionData from 'country-region-data/dist/data-umd';
import axios from 'axios'
// const countryRegionData = require('country-region-data');


const Checkout = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [regions, setRegions] = useState([])
  const [formData, setFormData] = useState({
    fullName: '',
    AddressLine1: '',
    AddressLine2: '',
    City: '',
    State: '',
    PostalCode: ''
  })
  const [paymentData,setPaymentData] = useState({
    number: '',
    expiry: '',
    cvc: '',
    name: '',
    focus: '',
  })
  const [loading, setLoading] = useState(true)
  const [subTotal, setSubTotal] = useState(0)
  const [cartItems, setCartItems] = useState([])
  const fetchCartItems = async () => {
    setLoading(true)
    const items = await getCartItems()
    let price = 0
    items.map((item) => {
      price += (item.quantity * item.ShowcasePrice.Value)
    })
    setSubTotal(price)
    setCartItems(items)
    setLoading(false)
  }
  useEffect(() => {
    fetchCartItems()
  }, [])
  useEffect(() => {
    let region;
    console.log(countryRegionData.length)
    countryRegionData.forEach(country => {
      if (country.countryShortCode == 'US') {
        region = country.regions
      }
    });
    setRegions(region)
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = async (e) => {
    debugger
    e.preventDefault()
    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    if (cartItems == 0) {
      messageApi.open({
        type: 'error',
        content: 'Add Products in Cart to Proceed',
      });
      return
    }
    if (cartItems) {
      const key = Date.now()
      messageApi.open({
        key,
        type: 'loading',
        content: 'Processing',
      });
      const products = await getCartItems()
      axios.post('/api/place-order', {
        ...formData,
        products
      }, {
        headers: {
          'Content-Type': 'application/json',
          // 'Accept': 'application/json',
        }
      }).then(response => {
        const result = response.data.result
        console.log('result', result)
        if (!result.Created) {
          result.Errors.map((item) => {
            messageApi.open({
              key,
              type: 'error',
              content: item.Message,
            });
          })
        } else {
          messageApi.open({
            key,
            type: 'success',
            content: `Order Placed Successfully.`,
          });
          setCartItems([])
          localStorage.removeItem('cart')
          fetchCartItems('cart')          
        }
      })
        .catch(error => {
          console.log('error', error)
        });
    }
  }

  return (
    <div className="checkout-page">
      <h1>Checkout</h1>
      <form className="shipping-form" onSubmit={handleSubmit}>
        {loading ? <div className="page-loader"><Spin size="large" /></div> : <div className="checkout-container">
          <div className="order-summary">
            <h2>Order Summary</h2>
            {cartItems.map((item, ind) => {
              return (<div className="order-item">
                <img
                  src={item.Images[0].FullUrl}
                  alt="Product"
                  className="product-image"
                />
                <div className="product-details">
                  <h3>{item.Description.substring(0, 50)}</h3>
                  <p>Ring Size: {item.ringSize}</p>
                  <p>Quantity: {item.quantity}</p>
                  <p>Price: ${(item.quantity * item.ShowcasePrice.Value).toFixed(2)}</p>
                </div>
              </div>)
            })}
            <div className="order-total">
              <p>Subtotal: ${subTotal.toFixed(2)}</p>
              <p>Shipping: $100.00</p>
              <p>Tax: $20.00</p>
              <h3>Total: ${(subTotal + 100 + 20).toFixed(2)}</h3>
            </div>
          </div>
          {/* Shipping Information Section */}
          <div className="shipping-info">
            <h2>Shipping Information</h2>

            <div className="form-group">
              <label>Full Name</label>
              <input value={formData.fullName} name='fullName' onChange={handleChange} type="text" placeholder="Enter your full name" required />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input value={formData.email} name='email' onChange={handleChange} type="email" placeholder="Enter your email" required />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input value={formData.phone} name='phone' onChange={handleChange} type="tel" placeholder="Enter your phone" required />
            </div>
            <div className="form-group">
              <label>Address</label>
              <input type="text" value={formData.AddressLine1} name='AddressLine1' onChange={handleChange} placeholder="123 Main Street" required />
              <input type="text" value={formData.AddressLine2} name='AddressLine2' onChange={handleChange} placeholder="Apt. 2" required />
            </div>
            <div className="form-group">
              <label>City</label>
              <input type="text" value={formData.City} name='City' onChange={handleChange} placeholder="Enter your city" required />
            </div>
            <div className="form-group">
              <label>State</label>
              <select value={formData.State} name='State' onChange={handleChange}>
                {regions.map((item, ind) => <option key={ind} value={item.shortCode}>{item.name}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Zip Code</label>
              <input type="text" value={formData.PostalCode} name='PostalCode' onChange={handleChange} placeholder="Enter your zip code" required />
            </div>
          </div>

          {/* Payment Details Section */}
          <div className="payment-details">
            <h2>Payment Details</h2>
            <div className="form-group">
              <label>Card Number</label>
              <input type="text" placeholder="Enter card number" required />
            </div>
            <div className="form-group">
              <label>Expiration Date</label>
              <input type="text" placeholder="MM/YY" required />
            </div>
            <div className="form-group">
              <label>CVV</label>
              <input type="text" placeholder="Enter CVV" required />
            </div>
          </div>
        </div>}

        {/* Place Order Button */}
        <button type='submit' className="place-order-button">Place Order</button>
      </form>
      {contextHolder}
    </div>
  );
};

export default Checkout;